import React from 'react';
import usePreviewStats, { RecipientLike } from '../../hooks/usePreviewStats';
import { ChannelType } from '../../hooks/useMessageValidation';

interface PreviewModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  channel: ChannelType;
  recipients: RecipientLike[];
  message: string;
  templateProvided: boolean;
  costConfig?: { AT?: number; FT?: number; SMS?: number; LMS?: number };
  disabled?: boolean; // send disabled
}

export const PreviewModal: React.FC<PreviewModalProps> = ({ open, onClose, onConfirm, channel, recipients, message, templateProvided, costConfig, disabled }) => {
  const stats = usePreviewStats({ channel, recipients, message, templateProvided, costConfig });
  if (!open) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ width: 520, maxWidth: '90%', background: '#fff', borderRadius: 8, padding: 24, boxShadow: '0 6px 18px rgba(0,0,0,0.2)', fontFamily: 'sans-serif' }}>
        <h2 style={{ marginTop: 0 }}>전송 미리보기</h2>
        <section style={{ marginBottom: 16 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <tbody>
              <tr><td style={tdL}>총 수신자</td><td style={tdR}>{stats.total}</td></tr>
              {channel === 'AT' && <tr><td style={tdL}>알림톡 대상</td><td style={tdR}>{stats.alimtalkEligible}</td></tr>}
              {channel === 'FT' && <tr><td style={tdL}>친구톡 대상</td><td style={tdR}>{stats.friendtalkEligible}</td></tr>}
              {(channel === 'AT' || channel === 'FT') && <tr><td style={tdL}>SMS/LMS 대체</td><td style={tdR}>{stats.smsFallback}</td></tr>}
              <tr><td style={tdL}>메시지 바이트</td><td style={tdR}>{stats.bytes} bytes ({stats.messageType})</td></tr>
            </tbody>
          </table>
        </section>
        <section style={{ marginBottom: 16 }}>
          <h4 style={{ margin: '4px 0' }}>예상 비용 (플레이스홀더)</h4>
            <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}>
              {stats.cost.AT != null && <li>알림톡: {stats.cost.AT.toLocaleString()}원</li>}
              {stats.cost.FT != null && <li>친구톡: {stats.cost.FT.toLocaleString()}원</li>}
              {stats.cost.SMS != null && <li>SMS: {stats.cost.SMS.toLocaleString()}원</li>}
              {stats.cost.LMS != null && <li>LMS: {stats.cost.LMS.toLocaleString()}원</li>}
              <li><strong>합계: {stats.cost.totalEstimated?.toLocaleString()}원</strong></li>
            </ul>
        </section>
        {stats.warnings.length > 0 && (
          <section style={{ marginBottom: 16 }}>
            <div style={{ background: '#fff5e6', border: '1px solid #f5c16c', padding: 10, borderRadius: 4, fontSize: 12, color: '#8a5a00' }}>
              <strong>주의사항</strong>
              <ul style={{ margin: '4px 0 0 16px', padding: 0 }}>
                {stats.warnings.map((w,i) => <li key={i}>{w}</li>)}
              </ul>
            </div>
          </section>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <button type="button" onClick={onClose}>취소</button>
          <button type="button" onClick={onConfirm} disabled={disabled || stats.messageType === 'OVER'} style={{ background: '#2563eb', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 4, cursor: disabled || stats.messageType === 'OVER' ? 'not-allowed' : 'pointer' }}>전송 시작</button>
        </div>
      </div>
    </div>
  );
};

const tdL: React.CSSProperties = { padding: '4px 6px', borderBottom: '1px solid #eee', color: '#555' };
const tdR: React.CSSProperties = { padding: '4px 6px', borderBottom: '1px solid #eee', textAlign: 'right', fontWeight: 500 };

export default PreviewModal;
